import axios from 'axios'
import router from '@/router'
import swal from 'sweetalert'
// import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    token: null,
    user: null,
    isLoading: false,
    loginAlert: null
  },

  mutations: {
    SET_TOKEN (state, token) {
      state.token = token
    },
    SET_USER (state, user) {
      state.user = user
    },
    SET_LOADING (state, isLoading) {
      state.isLoading = isLoading
    },
    SET_LOGIN_ALERT (state, alert) {
      state.loginAlert = alert
    }
  },
  getters: {
    authenticated (state) {
      if (state.user && state.token) {
        return true
      } else {
        return false
      }
    },
    user (state) {
      return state.user
    },
    isLoading (state) {
      return state.isLoading
    },
    loginAlert (state) {
      return state.loginAlert
    }
  },

  actions: {
    // login tanpa MFA
    // async login ({dispatch, commit}, credentials) {
    //   await commit('SET_LOADING', true)
    //   commit('SET_LOGIN_ALERT', null)
    //   // await axios.post('otentikasi/signin', credentials).then(function (response) {
    //   //   // console.log(response.data.token)
    //   //   dispatch('attempt', response.data.token)
    //   //   // setTimeout(() => {, 5000)})
    //   // }).then(() => {
    //   //   setTimeout(() => {
    //   //     router.push({ path: 'dashboard' })
    //   //     commit('SET_LOADING', false)
    //   //   }, 500)
    //   // })
    //   let response = await axios.post('otentikasi/signin', credentials).catch((error) => {
    //     // console.log(JSON.stringify(error))
    //     if (error.response.status === 401) {
    //       swal('error', 'Username/password tidak sesuai', 'error')
    //     } else {
    //       swal('error', error.response.statusText, 'error')
    //     }
    //     commit('SET_LOADING', false)
    //     commit('SET_LOGIN_ALERT', true)
    //     return error
    //   })
    //   // commit('SET_LOADING', false)
    //   if (typeof response.data !== 'undefined') return dispatch('attempt', response.data.token)
    // },

    // login dengan MFA
    async login ({ dispatch, commit }, credentials) {
      commit('SET_LOADING', true)
      commit('SET_LOGIN_ALERT', null)

      try {
        // Kirim permintaan login ke backend
        let response = await axios.post('otentikasi/signin', credentials)

        // Cek apakah pengguna memerlukan setup atau verifikasi 2FA
        if (response.data.tfa_required) {
          // Jika 2FA sudah diaktifkan, kembalikan respons ke login.vue
          return { data: { tfa_required: true } }
        // } else if (response.data.tfa_setup_needed) {
        //   // Jika pengguna belum mengatur 2FA, arahkan untuk setup 2FA
        //   return { data: { tfa_setup_needed: true } }
        } else if (response.data.tfa_verification_needed) {
          return { data: { tfa_verification_needed: true } }
        } else {
          // Jika tidak, lanjutkan autentikasi seperti biasa
          dispatch('attempt', response.data.token)

          // Redirect setelah login berhasil
          setTimeout(() => {
            commit('SET_LOADING', false)
            router.push({ path: 'dashboard' })
          }, 1000)
        }
      } catch (error) {
        // Jika terjadi error, tampilkan pesan
        swal('Error', 'Username/password tidak sesuai', 'error')
        commit('SET_LOADING', false)
        commit('SET_LOGIN_ALERT', true)
      }
    },

    async attempt ({state, commit}, token) {
      // console.log(token)
      if (token) {
        commit('SET_TOKEN', token)
        // console.log('ngecomit kok')
      }

      if (!state.token) {
        return
      }

      try {
        await axios.get('otentikasi/me').then(function (response) {
          commit('SET_USER', response.data)
        })
        //    .catch( error => {
        //        // swal('error', 'Email/Password yang ada masukan salah', 'error')
        //        commit('SET_USER', null)
        //        commit('SET_TOKEN', null)
        //        router.push({ path: 'login' })
        //      }
        //    )
      } catch (e) {
        commit('SET_USER', null)
        commit('SET_TOKEN', null)
        router.push({path: 'login'})
      }
    },
    async logout ({state, commit}) {
      if (state.token == null) {
        router.push({path: 'login'})
      }
      return axios.post('otentikasi/signout').then(() => {
        commit('SET_USER', null)
        commit('SET_TOKEN', null)
        // Vue.$toast.info('Berhasil Logout')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js